var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoVideoPlayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "player") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CASO-DRA-MENA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00-I",
    transform: "translate(-46.000000, -111.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5,111.000002 C49.3578628,111.000002 46,114.357868 46,118.500002 C46,122.642135 49.3578628,126.000002 53.5,126.000002 C57.6421301,126.000002 61,122.642135 61,118.500002 C61.0015801,116.510392 60.2119139,114.601817 58.8050475,113.19495 C57.3981811,111.788084 55.4896053,110.998418 53.5,111.000002 L53.5,111.000002 Z M57.0019868,119.229085 L51.7071686,122.282868 C51.4820536,122.407254 51.2080559,122.403829 50.9861201,122.273856 C50.7641843,122.143882 50.6271474,121.90659 50.6254958,121.649402 L50.6254958,115.3506 C50.6271474,115.093412 50.7641843,114.85612 50.9861201,114.726147 C51.2080559,114.596173 51.4820536,114.592749 51.7071686,114.717134 L57.0318673,117.956177 C57.2595314,118.090351 57.3967701,118.337214 57.3905685,118.601402 C57.3843669,118.86559 57.235696,119.10574 57.0019868,119.229085 Z",
    id: "player"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVideoPlayer);
export default __webpack_public_path__ + "static/media/ico-video-player.1e45e1204bfd05db07bc2c61233bdf09.svg";
export { ForwardRef as ReactComponent };